import * as React from "react";
import GoldLink from "src/presentation/common/atom/btn/gold_link";
import styled from "styled-components";
import {
  ConstBorderRound,
  ConstBreakPoint,
} from "../../../../config/styles_const/styles_const";
import { TMessageSignature } from "../../../type/common";
import BtnLinkBorderSmall from "../../atom/btn/btn_link_border_small";
import Paragraph from "../../atom/text/paragraph";
import ParagraphSup from "../../atom/text/paragraph_sup";

interface IProps {
  opponentSignature: TMessageSignature | null;
  opponentURL?: string;
  thumbnailHeight?: string;
}

const MessageRoomOpponentInfo: React.FC<IProps> = (props) => {
  const { opponentSignature, opponentURL, thumbnailHeight } = props;

  if (!opponentSignature) {
    return null;
  }

  return (
    <React.Fragment>
      <Wrapper>
        <Inner>
          <Img
            thumbnailHeight={thumbnailHeight}
            src={opponentSignature.iconURL}
          />
        </Inner>
        <Inner>
          <OpponentName bold={true}>{opponentSignature.name}</OpponentName>
        </Inner>
        <Inner>
          <OpponentDescription>
            {opponentSignature.description}
          </OpponentDescription>
        </Inner>
        {opponentURL && (
          <ButtonWrapper>
            <ProfileLink to={opponentURL}>プロフィール</ProfileLink>
          </ButtonWrapper>
        )}
      </Wrapper>
    </React.Fragment>
  );
};

export default MessageRoomOpponentInfo;

const Wrapper = styled.div`
  width: 100%;
  @media screen and (min-width: ${ConstBreakPoint.Default}) {
    margin-right: 35px;
  }
  @media screen and (min-width: ${ConstBreakPoint.PcDeskTop}) {
    margin-right: 0px;
  } ;
`;

const Inner = styled.div`
  margin-bottom: 10px;
`;

const Img = styled.img<{ thumbnailHeight?: string }>`
  width: 100%;
  height: ${(props) =>
    props.thumbnailHeight ? props.thumbnailHeight : "240px"};
  border-radius: ${ConstBorderRound.CornerRoundAll};
  object-fit: cover;
`;

const OpponentName = styled(Paragraph)`
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

const OpponentDescription = styled(ParagraphSup)`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

const ButtonWrapper = styled(Inner)`
  display: flex;
  justify-content: center;
`;

const CustomBtnLinkBorderSmall = styled(BtnLinkBorderSmall)`
  padding: 0 50px;
  font-weight: 700;
`;

const ProfileLink = styled(GoldLink)`
  font-size: 12px;
`;



// WEBPACK FOOTER //
// ./src/presentation/common/organism/message_room/message_room_opponent_info.tsx